import ArticleCard from '@/components/base/ArticleCard';
import SectionHeader from '@/components/base/SectionHeader';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const articles = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <SectionHeader
          title="精选文章"
          subtitle="深度解析苍井空人生故事的代表性文章"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.slice(0, 3).map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.slice(3, 6).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}